import {AntibodyEnforcedSchemaFieldSpec} from 'antibodies/schema-configuration/AntibodyEnforcedDataModelConstants';
import {FieldType} from 'schemas/fields/SchemaFieldConstants';
import {SchemaFieldSelector} from 'schemas/SchemaFieldSelectorConstants';

// Most enforced fields are automatically filled in by NDC, so we don't want to allow arbitrary migrated
// data in them. Dropdowns (aka selectors) are OK because they have a limited set of options, and we plan
// to let the schema admin explicitly choose how to migrate each option.
export const MIGRATABLE_FIELD_TYPES = new Set([FieldType.SELECTOR]);

export type DropdownFromSpec = NonNullable<
  AntibodyEnforcedSchemaFieldSpec['dropdown']
>['compatibleDropdowns'][number];

export function collateCompatibleDropdowns(
  enforcedFieldSpecs: Array<AntibodyEnforcedSchemaFieldSpec>
): Array<DropdownFromSpec> {
  const allDropdowns = enforcedFieldSpecs.map((spec) => spec.dropdown?.compatibleDropdowns ?? []).flat();
  const dropdownsById = allDropdowns.reduce<Record<string, DropdownFromSpec>>((acc, dropdown) => {
    if (dropdown != null) {
      acc[dropdown.id] = dropdown;
    }
    return acc;
  }, {});
  return Object.values(dropdownsById);
}

export function speccedDropdownToSchemaFieldSelector(dropdown: DropdownFromSpec): SchemaFieldSelector {
  return {
    id: dropdown.id,
    name: dropdown.name,
    schemaFieldSelectorOptions: dropdown.schemaFieldSelectorOptions.map((option) => ({
      id: option.id,
      name: option.name,
      archiveRecord: option.archiveRecord,
    })),
    allSchemaFieldSelectorOptions: dropdown.allSchemaFieldSelectorOptions.map((option) => ({
      id: option.id,
      name: option.name,
      archiveRecord: option.archiveRecord,
    })),
    archiveRecord: dropdown.archiveRecord,
  };
}
